/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_3_AnswerInputs */

const en_svc_agents_faq_3_answer = /** @type {(inputs: Svc_Agents_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on the task, the tools involved and how much needs review. After a short discovery we propose a fixed scope, timeline and price for a first agent, before any building starts.`)
};

const lv_svc_agents_faq_3_answer = /** @type {(inputs: Svc_Agents_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tas atkarīgs no uzdevuma, iesaistītajiem rīkiem un tā, cik daudz jāpārbauda cilvēkam. Pēc īsas izpētes piedāvājam fiksētu apjomu, termiņu un cenu pirmajam aģentam, pirms sākas izstrāde.`)
};

/**
* | output |
* | --- |
* | "It depends on the task, the tools involved and how much needs review. After a short discovery we propose a fixed scope, timeline and price for a first agent,..." |
*
* @param {Svc_Agents_Faq_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_3_answer = /** @type {((inputs?: Svc_Agents_Faq_3_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_3_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_3_answer(inputs)
	return en_svc_agents_faq_3_answer(inputs)
});